<div
  class="percentage-field"
  [ngClass]="{
    'has-value': internalFormControl.value !== undefined,
    condensed: condensed
  }"
>
  <label
    class="percentage-label field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
    [attr.for]="fieldId"
    type="text"
  >
    {{ label }}
  </label>

  <div class="percentage-wrapper">
    <input
      class="percentage-input"
      [ngClass]="{ invalid: formControl?.dirty && formControl?.invalid }"
      focusable
      tabindex="0"
      [formatAsNumber]="formatAsNumberOptions"
      type="text"
      [attr.id]="fieldId"
      [attr.data-e2e-id]="e2eId"
      [value]="initialValue"
      [formControl]="internalFormControl"
      (onBlur)="onBlur.emit()"
      (onFocus)="onFocus.emit()"
    />

    <app-error-message
      [fieldControl]="formControl"
      [errorMessage]="errorMessage"
    >
    </app-error-message>
  </div>
</div>
